import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import CartListDynamic from '../components/CartListDynamic';
import BillingForm from '../components/billing-form/BillingForm';
import PurchaseSuccess from '../components/PurchaseSuccess';
import PurchaseError from '../components/PurchaseError';
import AmountSelector from '../components/AmountSelector';
import FacebookPixelPurchase from '../components/FacebookPixelPurchase';
import { CURRENCIES } from '../constants/currencies';
import { T } from '../stores/textStore';
import TkcSameOriginService from '../services/TkcWebSameOriginService';

class DonationTicketView extends Component {

	constructor(props) {
		super(props);
		this.state = {
			billingStage: false,
		}
		/*
		this.props.shopStore.cashsale.set({
			ordernumber: '123', 
			total: '9', 
			currencysymbol: 'USD',        
		});
		*/
		//this.props.shopStore.purchaseError.set('This is the error message.');
	}

	handleClick = event => {
		event.preventDefault();
		const { shopStore } = this.props;
		shopStore.setCart([]);
	}

	renderChanukahPdfDownload() {
		const tickets = ['259426', '659770', '656873'];		
		console.log('TICKET_ID', window.tkcWidgetContext.ticketId);
		console.log('INDEX_OF', tickets.indexOf(window.tkcWidgetContext.ticketId));			
		if (tickets.indexOf(window.tkcWidgetContext.ticketId) === -1) {
			console.log('INDEX_OF_CONDITION_FAILED');
			return null;
		}
		const { shopStore } = this.props;
		const cashsale = shopStore.cashsale.get();
		console.log('CASHSALE', cashsale);
		console.log('CASHSALE', cashsale.total);
		console.log('CASHSALE_TOTAL_BELOW', cashsale.total < 10);
		if (cashsale.total < 10) {
			console.log('CASHSALE_TOTAL_CONDITION_FAILED');
			return null;
		}	
		const { billingInfo } = shopStore;
		const email = billingInfo.get('email');
		const name = billingInfo.get('firstname') + ' ' + billingInfo.get('lastname');
		const listId = '1c41a70805e9eed664819314cb4a8a33';	
		TkcSameOriginService.subscribeToEmailList(email, name, listId);
		const url = 'https://my.kabbalah.com/files/holidays/hand_out_guide-chanukah_20201124_eng.pdf ';
		return (
			<div className="container my-4">				
				<div className="row">
					<div className="col-12 text-center">			
						<div class="card">
							<div class="card-header">
								Chanukah Guide
							</div>
							<div class="card-body">
								<h5 class="card-title">Get Your Free Chanukah Guide!</h5>
								<p class="card-text">
									Your contribution is eligible for a free PDF download of our Chanukah Guide.
								</p>
								<a href={url} target="_blank" class="btn tkc-btn-red font-weight-bold">
									Download Now
								</a>
							</div>
						</div>	
					</div>
				</div>
			</div>
		);	
	}

	render() {			
		const { shopStore } = this.props;
		const cashsale = shopStore.cashsale.get();
		const purchaseError = shopStore.purchaseError.get();
		const context = window.tkcWidgetContext;
		if (purchaseError) {
			return <PurchaseError message={purchaseError} />
	  	} else if (cashsale) {	
			if (typeof(window.gtag) === 'function') {			  
				let analyticsPurchasePayload = {             
					"transaction_id": cashsale.ordernumber,
					//"affiliation": "Google online store",
					"value": cashsale.total.replace(',', ''),
					"currency": cashsale.currencysymbol,
					"tax": 0,
					"shipping": 0,
					"items": [
					{
						"id": cashsale.lineitems[0].itemname,
						"name": cashsale.lineitems[0].itemname,
						//"list_name": "Search Results",
						//"brand": "Google",
						"category": "PWYC",
						"variant": context.ga_variant,
						//"list_position": 1,
						"quantity": 1,
						"price": cashsale.total.replace(',', ''),
					},
					],				
				}     
				//console.log('GGGGGGGGG', analyticsPurchasePayload);   
				window.gtag('event', 'purchase', analyticsPurchasePayload);					
			}
			return (
				<span>
					<PurchaseSuccess 
						orderNumber={cashsale.ordernumber} 
						total={cashsale.total} 
						isDonation={false}
						currencyCode={cashsale.currencysymbol}
					/>
					{this.renderChanukahPdfDownload()}
					<FacebookPixelPurchase />
					{/*<PurchaseSuccess 
						orderNumber={1} 
						total={100.00} 
						isDonation={false}
						currencyCode={'USD'}
					/>*/}					
					{context.streamUrl &&
					<div className="container my-4">				
						<div className="row">
							<div className="col-12 text-center">
								<h5>You now have access to the live stream.</h5>
								<a 
										href={context.streamUrl} 
										className="btn btn-lg tkc-btn-red font-weight-bold px-5 mb-4"
								>
									Go To Stream
								</a>								
							</div>
						</div>
					</div>
					}
				</span>
			);
		} else if (shopStore.cart.get('items').length === 0) {
			return (
				<AmountSelector />
			);
		}		
		return (
			<div className="container">				
				<div className="row">
					<div className="col-md-12">
						<a href="" onClick={this.handleClick}>
							&lt;&lt; {T('Back to amount')}
						</a>
					</div>
				</div>
				<hr />
				<br />
				<div className="row">
					<div className="col-lg-4 order-lg-2 mb-4">
						<CartListDynamic />						
					</div>
					{shopStore.cart.get('hypoCashsale') &&
						<div className="col-lg-8 order-lg-1">
							<BillingForm />					
						</div>									
					}
				</div>
			</div>
		);
	}

}

export default inject('shopStore')(observer(DonationTicketView));




// WEBPACK FOOTER //
// ./src/views/DonationTicketView.js